import React from "react";
import { ELSA_BRAND_ASSETS } from "../../config/brandAssets";
import "./ElsaAdaptiveEmblem.css";

const ElsaAdaptiveEmblem = ({ className = "", alt = "ELSA GESTION" }) => (
  <span
    className={`elsa-adaptive-emblem ${className}`.trim()}
    role={alt ? "img" : undefined}
    aria-label={alt || undefined}
    aria-hidden={alt ? undefined : "true"}
  >
    <img
      className="elsa-adaptive-emblem__image elsa-adaptive-emblem__image--light"
      src={ELSA_BRAND_ASSETS.emblemColor}
      alt=""
      aria-hidden="true"
    />
    <img
      className="elsa-adaptive-emblem__image elsa-adaptive-emblem__image--dark"
      src={ELSA_BRAND_ASSETS.emblemWhite}
      alt=""
      aria-hidden="true"
    />
  </span>
);

export default ElsaAdaptiveEmblem;

